/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { platformRequestOption } from 'hooks/PlatformContext';
import { IApiRequest } from 'interfaces/apiRequestInterface';

const refreshToken = localStorage.getItem('refreshToken');

type RequestHeaders = {
  [key: string]: string;
};

const apiRequest = async ({
  url,
  payload,
  method,
}: IApiRequest): Promise<AxiosResponse> => {
  const requestHeader: RequestHeaders = platformRequestOption.requestHeader({
    token: refreshToken || '',
  });

  const requestData = {
    ...platformRequestOption.requestData,
    ...(payload as Record<string, unknown>),
  };

  const postRequestOptions: AxiosRequestConfig = {
    method: method,
    headers: requestHeader,
    data: JSON.stringify(requestData),
    url: `${platformRequestOption.url}/${url}`,
    withCredentials: true,
  };

  const fetchRequestOptions: AxiosRequestConfig = {
    method: method,
    headers: requestHeader,
    url: `${platformRequestOption.url}/${url}`,
    withCredentials: true,
  };

  const config: AxiosRequestConfig = ['POST', 'PUT', 'DELETE'].includes(method)
    ? postRequestOptions
    : fetchRequestOptions;

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data;
    } else {
      throw error;
    }
  }
};

export default apiRequest;
